// extracted by mini-css-extract-plugin
export var displayNone = "_rt-6";
export var imgContainer = "_rt-2";
export var overflowHidden = "_rt-3";
export var productInfoCardButtonContainer = "_rt-5";
export var productTitleText = "_rt-4";
export var rightArrow = "_rt-1";
export var rightArrowContainer = "_rt-0";